import { useEffect } from "react";

type GlobalErrorHandlerProps = {
	onErrorCallback: (errorInfo: Error) => void;
	onPromiseRejectionCallback: (reason: Error) => void;
};

export const useGlobalErrorHandler = ({ onErrorCallback, onPromiseRejectionCallback }: GlobalErrorHandlerProps) => {
	useEffect(() => {
		const handleWindowError = (event: ErrorEvent) => {
			event.preventDefault();
			onErrorCallback(event.error);
		};

		const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
			// 이벤트 버블링 방지
			event.preventDefault();
			onPromiseRejectionCallback(new Error(event.reason));
		};

		window.addEventListener("error", handleWindowError);
		window.addEventListener("unhandledrejection", handleUnhandledRejection);

		return () => {
			window.removeEventListener("error", handleWindowError);
			window.removeEventListener("unhandledrejection", handleUnhandledRejection);
		};
	}, [onErrorCallback, onPromiseRejectionCallback]);
};
